const municipalities = {
	Αττική: [
		"Αθηναίων",
		"Αγίας Βαρβάρας",
		"Αγίας Παρασκευής",
		"Αγίου Δημητρίου",
		"Αγίων Αναργύρων-Καματερού",
		"Αιγάλεω",
		"Αμαρουσίου",
		"Αμφιθέας",
		"Ανατολικής Μάνης",
		"Ανθούσας",
		"Αργυρούπολης-Ελληνικού",
		"Ασπροπύργου",
		"Βάρης-Βούλας-Βουλιαγμένης",
		"Βριλησσίων",
		"Γαλατσίου",
		"Γλυφάδας",
		"Δάφνης-Υμηττού",
		"Διονύσου",
		"Ελευσίνας",
		"Ζωγράφου",
		"Ηλιούπολης",
		"Ηρακλείου",
		"Ιλίου",
		"Καισαριανής",
		"Καλλιθέας",
		"Κηφισιάς",
		"Κορυδαλλού",
		"Κρωπίας",
		"Λαυρεωτικής",
		"Λυκόβρυσης-Πεύκης",
		"Μάνδρας-Ειδυλλίας",
		"Μαραθώνος",
		"Μαρκοπούλου Μεσογαίας",
		"Μεγαρέων",
		"Μεταμόρφωσης",
		"Μοσχάτου-Ταύρου",
		"Νέας Ερυθραίας",
		"Νέας Ιωνίας",
		"Νέας Σμύρνης",
		"Νέου Ηρακλείου",
		"Νίκαιας-Αγίου Ιωάννη Ρέντη",
		"Παιανίας",
		"Παλαιού Φαλήρου",
		"Παλλήνης",
		"Πειραιώς",
		"Περιστερίου",
		"Πετρούπολης",
		"Πεύκης",
		"Ραφήνας-Πικερμίου",
		"Σαλαμίνας",
		"Σαρωνικού",
		"Σπάτων-Αρτέμιδος",
		"Ταύρου",
		"Φιλαδέλφειας-Χαλκηδόνος",
		"Φιλοθέης-Ψυχικού",
		"Χαϊδαρίου",
		"Χαλανδρίου",
		"Χολαργού-Παπάγου",
	],
	Θεσσαλονίκη: [
		"Αμπελοκήπων-Μενεμένης",
		"Βόλβης",
		"Δέλτα",
		"Θερμαϊκού",
		"Θέρμης",
		"Θεσσαλονίκης",
		"Καλαμαριάς",
		"Κορδελιού-Ευόσμου",
		"Λαγκαδά",
		"Νεάπολης-Συκεών",
		"Παύλου Μελά",
		"Πυλαίας-Χορτιάτη",
		"Ωραιοκάστρου",
	],
	Αιτωλοακαρνανίας: ["Αγρινίου", "Ακτίου-Βόνιτσας", "Αμφιλοχίας", "Θέρμου", "Μεσολογγίου", "Ναυπακτίας", "Ξηρομέρου"],
	Αργολίδας: ["Άργους-Μυκηνών", "Επιδαύρου", "Ερμιονίδας", "Ναυπλιέων"],
	Αρκαδίας: ["Γορτυνίας", "Μεγαλόπολης", "Νότιας Κυνουρίας", "Τρίπολης", "Βόρειας Κυνουρίας"],
	Άρτας: ["Αρταίων", "Γεωργίου Καραϊσκάκη", "Κεντρικών Τζουμέρκων", "Νικολάου Σκουφά"],
	Αχαΐας: ["Αιγιαλείας", "Δυτικής Αχαΐας", "Καλαβρύτων", "Πατρέων"],
	Βοιωτίας: ["Αλιάρτου-Θεσπιέων", "Διστόμου-Αράχωβας-Αντίκυρας", "Λεβαδέων", "Ορχομενού", "Τανάγρας", "Θηβαίων"],
	Γρεβενών: ["Γρεβενών", "Δεσκάτης"],
	Δράμας: ["Δοξάτου", "Δράμας", "Κάτω Νευροκοπίου", "Παρανεστίου", "Προσοτσάνης"],
	Δωδεκανήσου: [
		"Αγαθονησίου",
		"Αστυπάλαιας",
		"Καλυμνίων",
		"Καρπάθου",
		"Κάσου",
		"Κω",
		"Λειψών",
		"Λέρου",
		"Μεγίστης",
		"Νισύρου",
		"Πάτμου",
		"Ρόδου",
		"Σύμης",
		"Τήλου",
		"Χάλκης",
	],
	Έβρου: ["Αλεξανδρούπολης", "Διδυμοτείχου", "Ορεστιάδας", "Σαμοθράκης", "Σουφλίου"],
	Εύβοιας: [
		"Αιδηψού",
		"Αλιβερίου-Κύμης",
		"Διρφύων-Μεσσαπίων",
		"Ερέτριας",
		"Ιστιαίας-Αιδηψού",
		"Καρύστου",
		"Κύμης-Αλιβερίου",
		"Μαντουδίου-Λίμνης-Αγίας Άννας",
		"Σκύρου",
		"Χαλκιδέων",
	],
	Ευρυτανίας: ["Αγράφων", "Καρπενησίου"],
	Ζακύνθου: ["Ζακύνθου"],
	Ηλείας: [
		"Ανδρίτσαινας-Κρεστένων",
		"Αρχαίας Ολυμπίας",
		"Αμαλιάδας",
		"Ανδραβίδας-Κυλλήνης",
		"Ζαχάρως",
		"Ήλιδας",
		"Πηνειού",
		"Πύργου",
	],
	Ημαθίας: ["Αλεξάνδρειας", "Βέροιας", "Νάουσας"],
	Ηρακλείου: [
		"Αρχανών-Αστερουσίων",
		"Βιάννου",
		"Γόρτυνας",
		"Ηρακλείου",
		"Μαλεβιζίου",
		"Μινώα Πεδιάδας",
		"Φαιστού",
		"Χερσονήσου",
	],
	Θεσπρωτίας: ["Ηγουμενίτσας", "Σουλίου", "Φιλιατών"],
	Ιωαννίνων: ["Βορείων Τζουμέρκων", "Δωδώνης", "Ζαγορίου", "Ζίτσας", "Ιωαννιτών", "Κόνιτσας", "Μετσόβου", "Πωγωνίου"],
	Καβάλας: ["Καβάλας", "Νέστου", "Παγγαίου", "Θάσου"],
	Καρδίτσας: ["Αργιθέας", "Καρδίτσας", "Λίμνης Πλαστήρα", "Μουζακίου", "Παλαμά", "Σοφάδων"],
	Καστοριάς: ["Άργους Ορεστικού", "Καστοριάς", "Νεστορίου"],
	Κέρκυρας: ["Βόρειας Κέρκυρας", "Κεντρικής Κέρκυρας και Διαποντίων Νήσων", "Νότιας Κέρκυρας", "Παξών"],
	Κεφαλληνίας: ["Αργοστολίου", "Ληξουρίου", "Σάμης", "Ιθάκης"],
	Κιλκίς: ["Κιλκίς", "Παιονίας"],
	Κοζάνης: ["Βοΐου", "Εορδαίας", "Κοζάνης", "Σερβίων"],
	Κορινθίας: [
		"Βέλου-Βόχας",
		"Γορτυνίας",
		"Κορινθίων",
		"Λουτρακίου-Περαχώρας-Αγίων Θεοδώρων",
		"Νεμέας",
		"Ξυλοκάστρου-Ευρωστίνης",
		"Σικυωνίων",
	],
	Κυκλάδων: [
		"Αμοργού",
		"Άνδρου",
		"Αντιπάρου",
		"Θήρας",
		"Ίου",
		"Κέας",
		"Κύθνου",
		"Μήλου",
		"Μυκόνου",
		"Νάξου και Μικρών Κυκλάδων",
		"Πάρου",
		"Σέριφου",
		"Σίφνου",
		"Σικίνου",
		"Σύρου-Ερμούπολης",
		"Τήνου",
		"Φολεγάνδρου",
	],
	Λακωνίας: ["Ανατολικής Μάνης", "Ελαφονήσου", "Ευρώτα", "Μονεμβασίας", "Σπάρτης"],
	Λάρισας: ["Αγιάς", "Ελασσόνας", "Κιλελέρ", "Λαρισαίων", "Τεμπών", "Τυρνάβου", "Φαρσάλων"],
	Λασιθίου: ["Αγίου Νικολάου", "Ιεράπετρας", "Οροπεδίου Λασιθίου", "Σητείας"],
	Λέσβου: ["Δυτικής Λέσβου", "Μυτιλήνης", "Λήμνου", "Αγίου Ευστρατίου"],
	Λευκάδας: ["Λευκάδας", "Μεγανησίου"],
	Μαγνησίας: [
		"Αλμυρού",
		"Βόλου",
		"Ζαγοράς-Μουρεσίου",
		"Νοτίου Πηλίου",
		"Ρήγα Φεραίου",
		"Σκιάθου",
		"Σκοπέλου",
		"Αλοννήσου",
	],
	Μεσσηνίας: ["Δυτικής Μάνης", "Καλαμάτας", "Μεσσήνης", "Οιχαλίας", "Πύλου-Νέστορος", "Τριφυλίας"],
	Ξάνθης: ["Αβδήρων", "Μύκης", "Ξάνθης", "Τοπείρου"],
	Πέλλας: ["Αλμωπίας", "Έδεσσας", "Πέλλας", "Σκύδρας"],
	Πιερίας: ["Δίου-Ολύμπου", "Κατερίνης", "Πύδνας-Κολινδρού"],
	Πρέβεζας: ["Ζηρού", "Πάργας", "Πρέβεζας"],
	Ρεθύμνης: ["Αγίου Βασιλείου", "Αμαρίου", "Μυλοποτάμου", "Ρεθύμνης"],
	Ροδόπης: ["Αρριανών", "Ιάσμου", "Κομοτηνής", "Μαρωνείας-Σαπών"],
	Σάμου: ["Ανατολικής Σάμου", "Δυτικής Σάμου", "Ικαρίας", "Φούρνων Κορσεών"],
	Σερρών: ["Αμφίπολης", "Βισαλτίας", "Εμμανουήλ Παππά", "Ηράκλειας", "Νέας Ζίχνης", "Σερρών", "Σιντικής"],
	Τρικάλων: ["Καλαμπάκας", "Μετεώρων", "Πύλης", "Τρικκαίων", "Φαρκαδόνας"],
	Φθιώτιδας: [
		"Αμφίκλειας-Ελάτειας",
		"Δομοκού",
		"Καμένων Βούρλων",
		"Λαμιέων",
		"Λοκρών",
		"Μακρακώμης",
		"Μώλου-Αγίου Κωνσταντίνου",
		"Στυλίδας",
	],
	Φλώρινας: ["Αμυνταίου", "Πρεσπών", "Φλώρινας"],
	Φωκίδας: ["Δελφών", "Δωρίδος"],
	Χαλκιδικής: ["Αριστοτέλη", "Κασσάνδρας", "Νέας Προποντίδας", "Πολυγύρου", "Σιθωνίας"],
	Χανίων: ["Αποκορώνου", "Γαύδου", "Καντάνου-Σελίνου", "Κισσάμου", "Πλατανιά", "Σφακίων", "Χανίων"],
	Χίου: ["Οινουσσών", "Ψαρών", "Χίου"],
};

export default municipalities;
